import InfoBlock from "../../../../node_modules/@interness/web-core/src/content/legal/InfoBlock";
import InternessLogo from "../../../../node_modules/@interness/web-core/src/content/InternessLogo";
import * as React from 'react';
export default {
  InfoBlock,
  InternessLogo,
  React
};